// export const localapiurl = 'http://127.0.0.1:8001/api';
// // const liveapiurl = ''; 
// export const localurl = 'http://127.0.0.1:8001';



// local testing url 
  
// export const localapiurl = 'http://192.168.1.30:8001/api';
// // const liveapiurl = ''; 
// export const localurl = 'http://192.168.1.30:8001';
// production url


export const localapiurl = 'https://utan.corientbiz.com/api';
//const liveapiurl = ''; 
export const localurl = 'https://utan.corientbiz.com';
// https://utan.corientbiz.com/
